export type XpoSortDirection = 'asc' | 'desc';

export class XpoSortExpression {
  readonly column: any;
  readonly direction: string;

  constructor(column: string, direction?: XpoSortDirection) {
    this.column = column;
    this.direction = direction || 'asc';
  }
}
